import { Module } from 'vuex';
import { TransportCostState } from './type'
import { RootState } from '@/store/type'
import state from './state';
import getters from './getters';
import actions from './actions';
import mutations from './mutations';

export const transportCost: Module<TransportCostState, RootState> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};